import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";

function ChartBRV() {
    const data = [
        { name: 'Líquido', value: 25000, color: '#3B82F6' },
        { name: 'A Repassar', value: 375000, color: '#EAB308' }
    ];

    return (
        <div className="w-full h-64 flex flex-col items-center justify-center">
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        innerRadius={55}
                        outerRadius={80}
                        paddingAngle={5}
                        dataKey="value"
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} stroke="#111317" strokeWidth={2} />
                        ))}
                    </Pie>
                    <Tooltip
                        formatter={(val) => `R$ ${Number(val).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`}
                        contentStyle={{ backgroundColor: '#111317', borderColor: '#262B34', borderRadius: '8px', color: '#fff' }}
                    />
                    <Legend verticalAlign="bottom" wrapperStyle={{ color: '#94A3B8', fontSize: '12px' }} />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}

export default ChartBRV;